"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { CustomLink } from "@repo/design-system/components/ui/custom-link";
import type { ErrorBoundaryProps } from "@repo/design-system/types/error-boundary";
import { cn } from "@repo/design-system/utils/cn";
import { buttonVariants } from "~/components/ui/button-eon";
export function ErrorPage(t0) {
  const $ = _c(14);
  const {
    error,
    reset,
    retry
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="relative aspect-square w-full max-w-sm"><CustomImage alt="" className="object-contain" fill={true} sizes="384px" src="images/page-404.png" /></div>;
    t2 = <h1 className="font-bold text-3xl md:text-4xl">Oops, something went wrong</h1>;
    t3 = <p className="text-lg text-muted-foreground">Don't worry – we're here to help!</p>;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== error.digest) {
    t4 = error.digest && <p className="text-muted-foreground text-xs">Error ID: {error.digest}</p>;
    $[3] = error.digest;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = cn(buttonVariants({
      variant: "default"
    }));
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = retry ?? reset;
  let t7;
  if ($[6] !== t6) {
    t7 = <button className={t5} onClick={t6} type="button">Try again</button>;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <CustomLink className="text-primary hover:underline" href="/">Back to home</CustomLink>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== t7) {
    t9 = <div className="flex flex-col gap-3 sm:flex-row">{t7}{t8}</div>;
    $[9] = t7;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t4 || $[12] !== t9) {
    t10 = <div className="mx-auto flex w-full max-w-3xl flex-col items-center gap-6 px-6 py-16 text-center md:py-24 print:hidden">{t1}{t2}{t3}{t4}{t9}</div>;
    $[11] = t4;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  return t10;
}